/* Delivery cost before checkout. Calls the same rate service the Shopify checkout calls,
   so the figure on the page is the figure charged. No data is stored beyond the postcode,
   which is kept in the browser so the shopper types it once. */
(function () {
  var ENDPOINT = 'https://santasvault-freight.netlify.app/rates?explain=1';   /* explain gives the blocked lines */
  var KEY = 'sv_pc';
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function items(box) {
    var el = box.querySelector('[data-sv-freight-items]');
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function currentSku(box) {
    var map = box.querySelector('[data-sv-freight-variants]');
    if (!map) return null;
    var byId;
    try { byId = JSON.parse(map.textContent); } catch (e) { return null; }
    var id = new URLSearchParams(location.search).get('variant');
    if (!id) {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input) id = input.value;
    }
    return id && byId[id] ? byId[id] : null;
  }
  function ask(box, pc) {
    var out = box.querySelector('[data-sv-freight-out]');
    var list = items(box);
    var sku = currentSku(box);
    if (sku) list = [{ sku: sku, quantity: 1 }];
    if (!list.length) return;
    out.removeAttribute('data-state');
    out.textContent = 'Checking…';
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ rate: { destination: { country: 'AU', postal_code: pc }, items: list, currency: 'AUD' } }),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        clearBlocked(box);
        if (d.rates && d.rates.length) {
          out.textContent = 'Delivery to ' + pc + ': ' + money(Number(d.rates[0].total_price)) + '. Sent by the supplier’s courier, usually 5 to 8 business days.';
        } else if (d.blocked && d.blocked.length && box.dataset.where === 'cart') {
          // Shopify cannot ship part of an order, so one of these stops the whole checkout.
          // Name them and offer to take them out, which is the only thing the shopper can do.
          out.setAttribute('data-state', 'bad');
          out.textContent = d.blocked.length === 1
            ? 'One item in your cart cannot be delivered to ' + pc + '.'
            : d.blocked.length + ' items in your cart cannot be delivered to ' + pc + '.';
          showBlocked(box, d, pc, list);
        } else {
          out.setAttribute('data-state', 'bad');
          out.textContent = 'The supplier cannot deliver this to ' + pc + '. Everything else on the site still ships there, and the checkout will not take an order we cannot send.';
        }
      })
      .catch(function () {
        out.setAttribute('data-state', 'bad');
        out.textContent = 'Could not check that just now. Delivery is quoted at the checkout once you enter your address.';
      });
  }
  function clearBlocked(box) {
    var el = box.querySelector('[data-sv-freight-blocked]');
    if (el) { el.hidden = true; el.textContent = ''; }
  }
  function remove(key, btn) {
    btn.disabled = true;
    btn.textContent = 'Removing…';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function () { location.reload(); }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Remove';
    });
  }
  function showBlocked(box, d, pc, list) {
    var el = box.querySelector('[data-sv-freight-blocked]');
    if (!el) return;
    var bySku = {};
    list.forEach(function (i) { bySku[i.sku] = i; });
    var ul = document.createElement('ul');
    d.blocked.forEach(function (b) {
      var line = bySku[b.sku] || {};
      var li = document.createElement('li');
      var name = document.createElement('span');
      name.textContent = line.title || b.sku;
      li.appendChild(name);
      if (line.key) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = 'Remove';
        btn.addEventListener('click', function () { remove(line.key, btn); });
        li.appendChild(btn);
      }
      ul.appendChild(li);
    });
    el.appendChild(ul);
    var rest = document.createElement('p');
    rest.className = 'sv-freight__rest';
    rest.textContent = (d.deliverable && d.deliverable.length)
      ? 'The rest of your cart can be delivered to ' + pc + '. Take these out and the order can go through.'
      : 'Take these out and the rest of your order can go through. The checkout cannot price an order we are unable to send.';
    el.appendChild(rest);
    el.hidden = false;
  }
  function wire(box) {
    var input = box.querySelector('[data-sv-freight-pc]');
    var go = box.querySelector('[data-sv-freight-go]');
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved) { input.value = saved; ask(box, saved); }
    function run() {
      var pc = (input.value || '').replace(/\D/g, '').slice(0, 4);
      if (pc.length !== 4) {
        var out = box.querySelector('[data-sv-freight-out]');
        out.setAttribute('data-state', 'bad');
        out.textContent = 'Enter a four digit Australian postcode.';
        return;
      }
      try { localStorage.setItem(KEY, pc); } catch (e) {}
      ask(box, pc);
    }
    go.addEventListener('click', run);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id' && box.dataset.where === 'product' && input.value) run();
    });
  }
  function init() { document.querySelectorAll('[data-sv-freight]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
